export const changeToAnalyticsFormat = (value: string) => {
  if (!value) {
    return;
  }
  const formattedValue = value.toLowerCase().split(" ").join("-");
  return formattedValue;
};


export const changeToAnalyticsFormatDots = (value: string) => {
  if (!value) {
    return;
  }
  const formattedValue = value.toLowerCase().split("..").join("-");
  return formattedValue;
};
